import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { TabEnum } from 'Common/Constants/Enumeration/WarehouseReports';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import {
  WAREHOUSE_KITCHEN_HOLD_FORM_NAME,
  WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME,
} from 'Common/FormEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import { errorToast } from 'Common/ToastHelper';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { getStorageLocationForCurrentSite } from 'State/filters/actions';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';

import WarehouseReportComponent from './../components/WarehouseReports';
import * as actions from './../state/actions';

import 'PageStyles/reports/inventory/warehouse.less';

class WarehouseReportsContainer extends Component {
  state = {
    headerInfo: TabEnum.NotSelected,
  };

  headerRowButtons = [
    { title: 'Hold', value: TabEnum.Hold, preferValue: PrefEnum.WarehouseHold },
    {
      title: 'Availability',
      value: TabEnum.Availability,
      preferValue: PrefEnum.WarehouseAvailability,
    },
  ];
  componentDidUpdate(prevProps, prevState) {
    const { clearPrintLoadingError } = this.props;
    if (errorToast(this.props, prevProps, 'printLoadingError')) {
      clearPrintLoadingError();
    }
  }

  componentDidMount() {
    if (
      !isPreferenceDisabled(
        PrefEnum.WarehouseHold,
        this.props.security.preferences
      )
    ) {
      this.setState({
        headerInfo: TabEnum.Hold,
      });
    } else if (
      !isPreferenceDisabled(
        PrefEnum.WarehouseAvailability,
        this.props.security.preferences
      )
    ) {
      this.setState({
        headerInfo: TabEnum.Availability,
      });
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  onHoldPrintClick = () => {
    this.props.submitForm(WAREHOUSE_KITCHEN_HOLD_FORM_NAME);
  };
  onHandleHoldPrintSubmit = values => {
    const requestJson = { ...values, [WarehouseReportEnum.Type]: 0 };
    this.props.getPrintHold(requestJson);
  };
  onAvailabilityPrintClick = () => {
    this.props.submitForm(WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME);
  };
  onHandleAvailabilityPrintSubmit = values => {
    const requestJson = { ...values, [WarehouseReportEnum.Type]: 1 };
    this.props.getPrintAvailability(requestJson);
  };

  changeTabSelection = value => {
    this.setState({
      headerInfo: value,
    });
  };
  getMainProps = () => {
    const {
      printWHKITHoldReportsLoading,
      printWHKITAvailabilityReportsLoading,
    } = this.props;
    const { headerInfo } = this.state;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick:
              headerInfo === TabEnum.Hold
                ? this.onHoldPrintClick
                : this.onAvailabilityPrintClick,
            loading:
              printWHKITHoldReportsLoading ||
              printWHKITAvailabilityReportsLoading,
          },
        ],
        shown: true,
      },
    };
  };
  render() {
    const { headerInfo } = this.state;
    return (
      <WarehouseReportComponent
        headerInfo={headerInfo}
        changeTabSelection={this.changeTabSelection}
        headerRowButtons={this.headerRowButtons}
        onHandleHoldPrintSubmit={this.onHandleHoldPrintSubmit}
        onHandleAvailabilityPrintSubmit={this.onHandleAvailabilityPrintSubmit}
        getMainProps={this.getMainProps}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { WarehouseReports } = state.ReportsState;
  const {
    printWHKITHoldReportsLoading,
    printWHKITAvailabilityReportsLoading,
    printLoadingError,
  } = WarehouseReports;
  ownProps.setPageLevelDirty(
    getIsDirty(WAREHOUSE_KITCHEN_HOLD_FORM_NAME)(state)
  );

  return {
    printWHKITHoldReportsLoading,
    printWHKITAvailabilityReportsLoading,
    printLoadingError,
    security: state.SecurityState,
  };
};
export const WarehouseReports = connect(
  mapStateToProps,
  {
    ...actions,
    submitForm,
    resetForm,
    getStorageLocationForCurrentSite,
  }
)(WarehouseReportsContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/containers/WarehouseReports.js